<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.application')"
    resource="applications"
    :onFormSubmit="handleSubmit"
    :actionButtons="['show', 'edit']"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { TAG_TYPE, SUBMITION_STATE } from '@/constants';
import WechatCategories from './wechat_categories';

@Component({
  components: {
    WechatCategories
  }
})
export default class Application extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  // get tabs() {
  //   return [
  //     {
  //       label: this.$t('application.miniProgram'),
  //       columns: this.columns(this.$createElement, { type: 'show' }),
  //     },
  //     {
  //       label: this.$t('model.wechatCategory'),
  //       can: 'wechat_categories.read',
  //       showAction: false,
  //       renderCell: (h, value) => {
  //         return <WechatCategories type="index" applicationSource={_.get(value, 'wechat_application.source')} h={h} />;
  //       }
  //     }
  //   ]
  // }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'wechat_application_appid_cont',
        label: 'AppID',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'name_cont',
        label: this.$t('application.name'),
        renderCell: {
          component: 'input'
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'wechat_application.appid',
        label: 'AppID',
        width: 150
      },
      {
        prop: 'name',
        label: this.$t('application.name'),
        width: 100,
      },
      {
        prop: 'logo',
        label: this.$t('application.logo'),
        width: 120,
        renderCell: {
          component: 'storageAttachment',
        }
      },
      // type === 'show' && {
      //   prop: 'desc',
      //   label: this.$t('application.desc'),
      // },
      // type === 'show' && {
      //   prop: 'share_title',
      //   label: this.$t('application.shareTitle'),
      // },
      type === 'show' && {
        prop: 'share_desc',
        label: this.$t('application.shareDesc'),
      },
      type === 'show' && {
        prop: 'share_image',
        label: this.$t('application.shareImage'),
        renderCell: {
          component: 'storageAttachment',
        }
      },
      type === 'show' && {
        prop: 'poster_image',
        label: this.$t('application.posterImage'),
        renderCell: {
          component: 'storageAttachment',
        }
      },
      type === 'show' && {
        prop: 'wechat_official_account_url',
        label: this.$t('application.wechatOfficialAccountURL'),
      },
      type === 'show' && {
        prop: 'home_top_logo',
        label: this.$t('application.homeTopLogo'),
        renderCell: {
          component: 'storageAttachment',
        }
      },
      type === 'show' && {
        prop: 'home_bottom_left_logo',
        label: this.$t('application.homeBottomLeftLogo'),
        renderCell: {
          component: 'storageAttachment',
        },
      },
      type === 'show' && {
        prop: 'questionaire_top_image',
        label: this.$t('application.questionaireTopImage'),
        renderCell: {
          component: 'storageAttachment',
        },
      },
      type === 'show' && {
        prop: 'questionaire_background_image',
        label: this.$t('application.questionaireBackgroundImage'),
        renderCell: {
          component: 'storageAttachment',
        },
      },
      type === 'show' && {
        prop: 'personal_center_background_image',
        label: this.$t('application.personalCenterBackgroundImage'),
        renderCell: {
          component: 'storageAttachment',
        },
      },
      type === 'show' && {
        prop: 'my_cards_background_image',
        label: this.$t('application.myCardsBackgroundImage'),
        renderCell: {
          component: 'storageAttachment',
        },
      },
      type === 'show' && {
        prop: 'creator.email',
        label: this.$t('adminUser.email'),
      },
      {
        prop: 'wechat_application.trial_submition.user_version',
        label: this.$t('application.wechatApplication.trialSubmition.userVersion'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>无</span>
          }
        }
      },
      type === 'show' && {
        prop: 'wechat_application.trial_submition.user_desc',
        label: this.$t('application.wechatApplication.trialSubmition.userDesc'),
      },
      type === 'show' && {
        prop: 'wechat_application.trial_submition.trial_version_qrcode',
        label: this.$t('application.wechatApplication.trialSubmition.trialVersionQrcode'),
        renderCell: {
          component: 'storageAttachment',
        }
      },
      {
        prop: 'wechat_application.online_submition.user_version',
        label: this.$t('application.wechatApplication.onlineSubmition.userVersion'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>无</span>
          }

        }
      },
      type === 'show' && {
        prop: 'wechat_application.online_submition.user_desc',
        label: this.$t('application.wechatApplication.onlineSubmition.userDesc'),
      },
      type === 'show' && {
        prop: 'wechat_application.qrcode_url',
        label: this.$t('application.wechatApplication.qrcodeURL'),
        width: 200,
        renderCell: {
          component: 'storageAttachment',
        }
      },
      {
        prop: 'wechat_application.audit_submition.user_version',
        label: this.$t('application.wechatApplication.auditSubmition.userVersion'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <span>{value}</span>
          } else {
            return <span>-</span>
          }
        }
      },
      type === 'show' && {
        prop: 'wechat_application.audit_submition.user_desc',
        label: this.$t('application.wechatApplication.auditSubmition.userDesc'),
      },
      {
        prop: 'wechat_application.audit_submition.state',
        label: this.$t('application.wechatApplication.auditSubmition.state'),
        width: 120,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <el-tag type={TAG_TYPE[value]}>{ SUBMITION_STATE[value] }</el-tag>;
          } else {
            return <span>-</span>
          }
        }
      },
      type === 'show' && {
        prop: 'wechat_application.audit_submition.reason',
        label: this.$t('application.wechatApplication.auditSubmition.reason'),
        renderCell: 'html'
      },
      {
        prop: 'expired_at',
        label: this.$t('application.expiredAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: this.$t('application.name'),
        renderCell: {
          component: 'input',
          required: true
        }
      },
      {
        prop: 'logo',
        label: this.$t('application.logo'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 150x150`,
          props: {
            cropper: {
              width: 150,
              height: 150
            }
          }
        }
      },
      // {
      //   prop: 'desc',
      //   label: this.$t('application.desc'),
      //   renderCell: {
      //     component: 'input',
      //   }
      // },
      // {
      //   prop: 'share_title',
      //   label: this.$t('application.shareTitle'),
      //   renderCell: {
      //     component: 'input',
      //   }
      // },
      {
        prop: 'share_desc',
        label: this.$t('application.shareDesc'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'share_image',
        label: this.$t('application.shareImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 500x400`,
          props: {
            cropper: {
              width: 500,
              height: 400
            }
          }
        }
      },
      {
        prop: 'poster_image',
        label: this.$t('application.posterImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 600x509`,
          props: {
            cropper: {
              width: 600,
              height: 509
            }
          }
        }
      },
      {
        prop: 'wechat_official_account_url',
        label: this.$t('application.wechatOfficialAccountURL'),
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'home_top_logo',
        label: this.$t('application.homeTopLogo'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 150x86`,
          props: {
            cropper: {
              width: 150,
              height: 86
            }
          }
        }
      },
      {
        prop: 'home_bottom_left_logo',
        label: this.$t('application.homeBottomLeftLogo'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 164x40`,
          props: {
            cropper: {
              width: 164,
              height: 40
            }
          }
        }
      },
      {
        prop: 'questionaire_top_image',
        label: this.$t('application.questionaireTopImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 429x57`,
          props: {
            cropper: {
              width: 429,
              height: 57
            }
          }
        }
      },
      {
        prop: 'questionaire_background_image',
        label: this.$t('application.questionaireBackgroundImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 750x1191`,
          props: {
            cropper: {
              width: 750,
              height: 1191
            }
          }
        }
      },
      {
        prop: 'personal_center_background_image',
        label: this.$t('application.personalCenterBackgroundImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 750x326`,
          props: {
            cropper: {
              width: 750,
              height: 326
            }
          }
        }
      },
      {
        prop: 'my_cards_background_image',
        label: this.$t('application.myCardsBackgroundImage'),
        renderCell: {
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 654x312`,
          props: {
            cropper: {
              width: 654,
              height: 312
            }
          }
        }
      },
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    const env = process.env.VUE_APP_ENV
    const wechat_application = row.wechat_application
    let canSubmitAudit = false
    let canRelease = false
    let canMockSubmitAudit = false
    let canMockRelease = false

    if (wechat_application) {
      if (wechat_application.trial_submition) {
        if (env === 'development') {
          canMockSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        } else {
          canSubmitAudit = !wechat_application.audit_submition || (wechat_application.audit_submition.state !== 'pending' && wechat_application.audit_submition.state !== 'delay')
        }
      }

      if (wechat_application.audit_submition) {
        if (env === 'development') {
          canMockRelease = wechat_application.audit_submition.state === 'success'
        } else {
          canRelease = wechat_application.audit_submition.state === 'success'
        }
      }
    }

    const handleSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockSubmitAudit = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_submit_audit`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleMockRelease = async (id) => {
      await this.$autoLoading(this.$request.post(`/wechat_third_party_platform/applications/${id}/mock_release`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    const handleBindWechat = async (isBinded) => {
      if (isBinded) {
        const { url } = await this.$request.get('wechat_third_party_platform/base/component_auth_url');
         window.location = url;
      } else {
        this.$router.push({ name: 'bind_exists_mini_program' });
      }
    }

    const expiredAtForm = [
      {
        prop: 'expired_at',
        label: this.$t('application.expiredAt'),
        renderCell: {
          component: 'dateTimePicker',
        }
      }
    ]
    const handleSubmitExpiredAtForm = async (value) => {
      await this.$autoLoading(this.$request.put(`/applications/${row.id}/update_expired_at`, value));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'applications.edit', params: { id: row.id } }
        }
      },
      canSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.submitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleSubmitAudit(row.wechat_application_id)
        }
      },
      canMockSubmitAudit && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateSubmitAudit'),
          type: 'primary',
          can: 'wtpp_applications.submit_audit'
        },
        on: {
          confirm: () => handleMockSubmitAudit(row.wechat_application_id)
        }
      },
      canRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.release'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleRelease(row.wechat_application_id)
        }
      },
      canMockRelease && {
        component: 'confirmButton',
        props: {
          label: this.$t('application.actions.simulateRelease'),
          type: 'primary',
          can: 'wtpp_applications.release'
        },
        on: {
          confirm: () => handleMockRelease(row.wechat_application_id)
        }
      },
      {
        functional: true,
        render: () => {
          const isBinded = _.get(row, 'wechat_application.id');
          return <el-button type="primary" size="mini" onClick={() => handleBindWechat(isBinded)}>{ isBinded ? this.$t('application.actions.reauthorization') : this.$t('application.actions.bindMiniProgram') }</el-button>
        }
      },
      {
        component: 'dialogFormButton',
        props: {
          label: this.$t('application.actions.updateExpiredAt'),
          columns: expiredAtForm,
          value: row,
          can: 'applications.update_expired_at',
          submitHandler: handleSubmitExpiredAtForm
        }
      }
    ].filter(Boolean);
  }

  async handleSubmit({ data, type, resource, namespace }) {
    if (type === 'new') {
      const response = await this.$request.post(`/${namespace}${resource}`, data);
      this.$message.success(this.$t('bean.createSuccess'));
      localStorage.setItem('currentRoleId', response.application_admin_users_role_id);
      this.$router.push({ name: 'home' });
      location.reload();
    } else {
      await this.$request.put(`/${namespace}${resource}/${data.id}`, data);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: `${resource}.show`, params: { id: data.id } });
    }
  }
}

export const route = [
  {
    path: '/applications',
    name: 'applications.index',
    component: Application,
    props: {
      type: 'index',
    }
  },
  {
    path: '/applications/new',
    name: 'applications.new',
    component: Application,
    props: {
      type: 'new',
    }
  },
  {
    path: '/applications/:id',
    name: 'applications.show',
    component: Application,
    props: {
      type: 'show',
    }
  },
  {
    path: '/applications/:id/edit',
    name: 'applications.edit',
    component: Application,
    props: {
      type: 'edit'
    }
  }
]
</script>
